import React, { useRef, useState, useEffect } from 'react';
import './RosaI.css'; // Assuming you have a CSS file for styling
import { Link } from 'react-router-dom';
import icon from './Images/Rosai.gif';

import distance from './Images/Distance.gif';

import { useNavigate } from 'react-router-dom';

function Rosai() {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem('userEmail');

  useEffect(() => {
    if (!userEmail) {
      navigate('/signin');
    }
  }, [userEmail, navigate]);  

  return (
  


    <div id="image-container">
        <img id="myimage" src={icon} alt="img" width="80" height="100" />
        <center>
        <h2 class="center-heading" style={{ color: 'pink', fontSize: '35px' }}>ROSA-I</h2>
        <h3 class="center-heading" style={{ color: 'pink', fontSize: '35px' }}>Main Page</h3>
        </center><br />
        <p>Signed in as: {userEmail}</p>
        <div className="app">
      

          <div className="button-container">
            <nav>
             <ul>
               
        
               <li>
                <Link to="/distance">
                <img src={distance} className="app-img" width="230" height="150" alt="img" />
                </Link>
               </li><br />
       
               

            </ul>
           </nav>
        </div>
      </div>

    
      <br />
      <footer class="footer-section">
        <div class="container-4">
          <div class="nav-items"></div>
          <div class="text-6">&copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.</div>
        </div>
     </footer>
  </div>
   
  );
}

export default Rosai;

